import { Link } from 'react-router-dom';

const directions = [
  {
    icon: 'ri-line-chart-line',
    title: 'Продажи',
    description: 'Техники активных продаж, работа с возражениями, выявление потребностей и закрытие сделок.',
    to: '/enciklopediya-korporativnogo-obucheniya/obuchenie-otdela-prodazh',
    color: 'from-teal-500 to-teal-600',
  },
  {
    icon: 'ri-shake-hands-line',
    title: 'Переговоры',
    description: 'Стратегии win-win, подготовка к сложным переговорам, психология влияния и аргументация.',
    to: '/prodazhi-i-peregovory/trening-po-peregovoram',
    color: 'from-emerald-500 to-emerald-600',
  },
  {
    icon: 'ri-star-line',
    title: 'Лидерство',
    description: 'Управленческие навыки, мотивация команды, делегирование и принятие стратегических решений.',
    to: '/enciklopediya-korporativnogo-obucheniya/trening-dlya-rukovoditeley',
    color: 'from-amber-500 to-amber-600',
  },
  {
    icon: 'ri-chat-1-line',
    title: 'Коммуникации',
    description: 'Эффективное общение, обратная связь, разрешение конфликтов и межличностное взаимодействие.',
    to: '/enciklopediya-korporativnogo-obucheniya/razvitie-soft-skills',
    color: 'from-cyan-500 to-cyan-600',
  },
  {
    icon: 'ri-brain-line',
    title: 'Soft Skills',
    description: 'Эмоциональный интеллект, тайм-менеджмент, стресс-менеджмент и адаптивность к изменениям.',
    to: '/enciklopediya-korporativnogo-obucheniya/razvitie-soft-skills',
    color: 'from-indigo-500 to-indigo-600',
  },
  {
    icon: 'ri-group-line',
    title: 'Командообразование',
    description: 'Тимбилдинги, бизнес-игры, формирование сплоченных команд и улучшение корпоративной культуры.',
    to: '/enciklopediya-korporativnogo-obucheniya/komandoobrazovanie',
    color: 'from-rose-500 to-rose-600',
  },
];

export default function PopularDirections() {
  return (
    <section id="popular" className="py-20 md:py-28 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-extrabold text-gray-900 mb-6 leading-tight">
            Самые популярные направления обучения сотрудников
          </h2>
          <p className="text-lg md:text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed">
            По статистике обращений и реализованных проектов, именно эти направления корпоративного обучения наиболее востребованы бизнесом.
          </p>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {directions.map((item) => (
            <Link
              key={item.title}
              to={item.to}
              className="group relative bg-white rounded-2xl overflow-hidden border border-gray-100 hover:shadow-xl transition-all duration-300 cursor-pointer"
            >
              {/* Gradient top bar */}
              <div className={`h-2 bg-gradient-to-r ${item.color}`}></div>
              <div className="p-8">
                <div className={`w-14 h-14 bg-gradient-to-br ${item.color} rounded-xl flex items-center justify-center mb-5 group-hover:scale-110 transition-transform`}>
                  <i className={`${item.icon} text-2xl text-white`}></i>
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-3 group-hover:text-teal-700 transition-colors">
                  {item.title}
                </h3>
                <p className="text-gray-600 text-sm leading-relaxed mb-4">{item.description}</p>
                <span className="inline-flex items-center gap-1 text-teal-600 font-semibold text-sm group-hover:gap-2 transition-all">
                  Подробнее
                  <i className="ri-arrow-right-line"></i>
                </span>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}